export default error => {
  return error[Object.keys(error)[0]][0]
}
